import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import FlipCard, { BoxCards } from "components/FlipCard";
import { useLanguage } from "context/LanguageContext";
import NormalizeText from "utils/NormalizeText";
import { Container } from "react-bootstrap"; // Usando o Bootstrap para estrutura
import { useNotification } from "context/NotificationContext"; // Importando o contexto de notificação

const Categoria = () => {
  const { id } = useParams(); // Obtendo o ID da URL
  const navigate = useNavigate();
  const { GetTranslation } = useLanguage();
  const notify = useNotification(); // Usando o hook do NotificationContext
  const [patientInfo, setPatientInfo] = useState(null); // Estado para armazenar as informações do paciente

  // Definindo ícones relacionados às categorias
  const icons = [
    "pi-user", // Identificação
    "pi-calendar", // Pré-operatório
    "pi-chart-line", // Escores
    "pi-plus-circle", // Anestesia
    "pi-times", // Incisão
    "pi-heart", // Circulação Extracorpórea
    "pi-sitemap", // Cirurgia
    "pi-heart-fill", // Pós-operatório
    "pi-inbox", // Hemotransfusão
    "pi-exclamation-circle", // Óbito
  ];

  // Definindo as rotas baseadas nas categorias
  const formsData = [
    { name: GetTranslation("Identificacao"), route: "/app/form/identificacao", description: GetTranslation("Identificacao_Descricao") },
    { name: GetTranslation("PreOperatorio"), route: "/app/form/pre-operatorio", description: GetTranslation("PreOperatorio_Descricao") },
    { name: GetTranslation("Escores"), route: "/app/form/escores", description: GetTranslation("Escores_Descricao") },
    { name: GetTranslation("Anestesia"), route: "/app/form/anestesia", description: GetTranslation("Anestesia_Descricao") },
    { name: GetTranslation("Incisao"), route: "/app/form/incisao", description: GetTranslation("Incisao_Descricao") },
    { name: GetTranslation("Circulacao_Extracorporea"), route: "/app/form/circulacao-extracorporea", description: GetTranslation("Circulacao_Extracorporea_Descricao") },
    { name: GetTranslation("Cirurgia"), route: "/app/form/cirurgia", description: GetTranslation("Cirurgia_Descricao") },
    { name: GetTranslation("PosOperatorio"), route: "/app/form/pos-operatorio", description: GetTranslation("PosOperatorio_Descricao") },
    { name: GetTranslation("Hemotransfusao"), route: "/app/form/hemotransfusao", description: GetTranslation("Hemotransfusao_Descricao") },
    { name: GetTranslation("Obito"), route: "/app/form/obito", description: GetTranslation("Obito_Descricao") },
  ];

  // Função para buscar as informações do paciente com base no ID
  useEffect(() => {
    if (id) {
      fetch(`${process.env.REACT_APP_API_URL}/identificacao/paciente/info/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Pegando o token do localStorage
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            setPatientInfo(data.paciente); // Armazena as informações do paciente
          } else {
            notify({
              type: "error",
              message: "Erro ao buscar informações do paciente",
            });
          }
        })
        .catch(() => {
          notify({
            type: "error",
            message: "Erro ao carregar as informações do paciente",
          });
        });
    }
  }, [id, notify]);

  return (
    <Container>
      {/* Header com informações do paciente */}
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <h1 className="text-center">{GetTranslation("Categories")}</h1>
        <div className="patient-info text-right">
          {/* Verifica se as informações do paciente estão disponíveis */}
          {patientInfo ? (
            <>
              <p>
                <strong>CPF:</strong> {patientInfo.cpf}
              </p>
              <p>
                <strong>{GetTranslation("Nome")}:</strong> {patientInfo.nome}
              </p>
            </>
          ) : (
            <p>{GetTranslation("Carregando")}</p>
          )}
        </div>
      </div>

      {/* Cartões Flip com as categorias */}
      <BoxCards>
        {formsData.map((form, index) => (
          <FlipCard
            key={index}
            to={`${form.route}/${id}`} // Usando o id da URL
            frontContent={{
              icon: `pi ${icons[index]}`,
              text: form.name,
            }}
            backContent={form.description}
          />
        ))}
      </BoxCards>

      {/* Botão de voltar */}
      <div className="d-flex justify-content-end">
        <Button className="btn btn-secondary" onClick={() => navigate("/app/home")}>
          {GetTranslation("Voltar")}
        </Button>
      </div>
    </Container>
  );
};

export default Categoria;
